var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { uuid4 } from '../utils/uuid';
import SimpleEvent from '../utils/simpleEvent';
import middlewareRunner from './middleware';
var NativeAppCommunicator = /** @class */ (function () {
    function NativeAppCommunicator(impl, onSendMiddleware, onReceiveMiddleware) {
        var _this = this;
        this.impl = impl;
        this.responseWaiters = new Map();
        this.onSendMiddleware = [];
        this.onReceiveMiddleware = [];
        this.messageReceived = new SimpleEvent();
        this.send = function (message) {
            var wrapped = _this.createDataEnvelope(message);
            return _this.doSend(wrapped);
        };
        this.addOnReceiveMiddleware = function (middleware) {
            _this.onReceiveMiddleware.push(middleware);
        };
        this.addOnSendMiddleware = function (middleware) {
            _this.onSendMiddleware.push(middleware);
        };
        this.processReceivedMessage = function (message) { return __awaiter(_this, void 0, void 0, function () {
            var result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.debug('Communicator received: ', message);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.runMessageReceivedMiddleware(message)];
                    case 2:
                        result = _b.sent();
                        if (result.purpose === 'response') {
                            this.handleResponse(result);
                        }
                        else {
                            // Pass this message to registered handlers.
                            this.messageReceived.trigger(result);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.handleResponse = function (message) {
            var response = message;
            var waiter = _this.responseWaiters.get(response.request_id);
            if (waiter) {
                waiter(response.response_data);
                _this.responseWaiters.delete(response.request_id);
            }
        };
        this.createDataEnvelope = function (message) {
            return {
                domain: message.domain,
                eventType: message.eventType,
                data: {
                    request_id: uuid4(),
                    data: message.data,
                },
            };
        };
        this.doSend = function (message) { return __awaiter(_this, void 0, void 0, function () {
            var domain, eventType, data, p, result, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        domain = message.domain, eventType = message.eventType, data = message.data;
                        p = new Promise(function (resolve) { return _this.responseWaiters.set(message.data.request_id, resolve); });
                        console.debug('Communicator sending: ', domain, eventType, data);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.runSendingMiddleware(message)];
                    case 2:
                        result = _b.sent();
                        this.impl.send(result.domain, result.eventType, result.data);
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, p];
                }
            });
        }); };
        this.runSendingMiddleware = function (message) {
            return middlewareRunner(_this.onSendMiddleware, _this.processReceivedMessage, message);
        };
        this.runMessageReceivedMiddleware = function (message) {
            return middlewareRunner(_this.onReceiveMiddleware, _this.send, message);
        };
        // Bind ourselves to listen for incoming messages
        this.impl.messageReceived.on(this.processReceivedMessage.bind(this));
        if (onSendMiddleware) {
            this.onSendMiddleware = onSendMiddleware;
        }
        if (onReceiveMiddleware) {
            this.onReceiveMiddleware = onReceiveMiddleware;
        }
    }
    return NativeAppCommunicator;
}());
export default NativeAppCommunicator;
//# sourceMappingURL=communicator.js.map